import React, { useCallback, useEffect, useState } from "react";
import { Card, Form, Button, Container, Row, Col } from "react-bootstrap";
import * as regex from "../constants/regex.ts";
import Loading from "../components/Loading.tsx";
import { requestSquematic } from "../constants/commonFunctions.ts";
import { useNavigate } from "react-router-dom";
import { userAuth } from "../constants/types.ts";

const Login: React.FC = () => {
  const [login, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [isValid, setIsValid] = useState({
    email: false,
    password: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = useCallback(async (email: string, password: string) => {
    setIsLoading(true);

    try {
      const res = await requestSquematic(
        "POST",
        "/api/app/user/login",
        {
          c001_clave: password,
          c001_correo_electronico: email,
          c001_token_dispositivo: null,
          idioma: "1",
        }
      );

      if (res && res.results) {
        const {
          token,
          user,
        } = res.results;

        const {
          c001_correo_electronico,
          c001_numero_celular,
          third,
          c001_rowid,
        } = user;

        const userLoged: userAuth = {
          login: true,
          user: {
            id: c001_rowid,
            email: c001_correo_electronico,
            phone: c001_numero_celular,
            photo:
              third?.attached_file?.c180_ruta?.replace(
                "images",
                "restored_image"
              ) ?? "",
            token,
            nit: user.third.c120_nit,
            name: user.third.c120_razon_social,
          }
        };

        //Se envian los datos a la vista payments
        navigate("/payment", { state: userLoged }); // Enviar datos a Payment
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      handleChange({ password: "" });
    }
  },
    [login, isValid]
  );

  useEffect(() => {
    setIsValid((state) => ({
      ...state,
      email: regex.email.test(login.email),
      password: regex.otp.test(login.password),
    }));
  }, [login, setIsValid]);

  const handleChange = useCallback(
    (value: any) => {
      setLoginData((state) => ({ ...state, ...value }));
    },
    [setLoginData]
  );

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/img/curva.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "100%",
        position: "relative",
      }}
    >
      {isLoading && <Loading />}
      <span
        style={{
          position: "absolute",
          backgroundPosition: "50%",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0.8,
          backgroundImage: "linear-gradient(310deg,#7928ca,#ff0080)",
        }}
      ></span>
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
        }}
      >
        <Row>
          <Col>
            <Card className="custom-card">
              <Card.Body>
                <Card.Title className="text-center py-2">
                  <img
                    src={require("../assets/img/logoluki.png")}
                    style={{
                      width: 100,
                      objectFit: "contain",
                      textAlign: "center",
                    }}
                  />
                </Card.Title>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 10 }}
                >
                  <Form.Group controlId="formEmail">
                    <Form.Label>Correo electrónico</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Ingresa tu correo"
                      value={login.email}
                      style={{ marginTop: -8 }}
                      onChange={(e) => handleChange({ email: e.target.value })}
                      required
                    />
                  </Form.Group>

                  <Form.Group controlId="formPassword">
                    <Form.Label>Contraseña</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Escribe tu contraseña"
                      value={login.password}
                      maxLength={4}
                      style={{ marginTop: -8 }}
                      onChange={(e) =>
                        handleChange({ password: e.target.value })
                      }
                      required
                    />
                  </Form.Group>
                </div>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 mt-3"
                  disabled={!isValid.email || !isValid.password}
                  onClick={() => handleSignIn(login.email, login.password)}
                >
                  Iniciar sesión
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <div style={{ position: "absolute", bottom: 0, right: 0 }}></div>
    </div>
  );
};

export default Login;
